// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderConfirmationBillingInformationStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsBillingInformation";
import { styledBoxStyle } from "@keller/App/Components/Common/StyledBox";
import OrderInformationStyles from "@keller/App/SharedStyle/MyAccount/Details/OrderInformationStyles";
import { hideElement, xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

orderConfirmationBillingInformationStyles.billingInformationGridContainer = {
    gap: 30,
};

orderConfirmationBillingInformationStyles.billingInformationTitleGridItem = {
    css: css`
        ${hideElement}
    `,
};

orderConfirmationBillingInformationStyles.billingAddressTitle = {
    ...OrderInformationStyles.address?.heading,
};

orderConfirmationBillingInformationStyles.billingInformationBillingAddressGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        width: 100%;

        address {
            width: 100%;
            border-radius: 4px;
            min-height: 100px;
            ${styledBoxStyle}

            ${xScreen("lte", "md")} {
                margin-bottom: 0;
            }
        }
    `,
};
